import React, { useState } from "react";
import ProfileTab from "./tabs/ProfileTab";
import FinanceTab from "./tabs/FinanceTab";
import ContractsTab from "./tabs/ContractsTab";

const NAV_ITEMS = [
  { key: "contracts", label: "قولنامه‌های من", icon: DocIcon },
  // { key: "finance", label: "مالی", icon: WalletIcon },
  { key: "profile", label: "پروفایل", icon: UserIcon },
];

export default function PanelLayout({
  onStartNewContract,
  onViewContract,
  onLogout,
  userName,
  canCreateAgreement = true,
  limitError = "",
}) {
  const [activeTab, setActiveTab] = useState("contracts");
  const [collapsed, setCollapsed] = useState(false);

  const activeLabel =
    NAV_ITEMS.find((i) => i.key === activeTab)?.label || "پنل کاربری";

  const renderTab = () => {
    if (activeTab === "profile") return <ProfileTab />;
    // if (activeTab === "finance") return <FinanceTab />;
    return <ContractsTab onViewContract={onViewContract} />;
  };

  const initial = (userName || "کاربر").charAt(0);

  // برچسب‌ها: تو تبلت همیشه جمع (فقط آیکون)، تو دسکتاپ بر اساس collapsed
  // هیچ کلاس متناقضی روی یک breakpoint یکسان قرار نمی‌گیره
  const labelClass = collapsed ? "hidden" : "hidden lg:inline";
  const rowJustify = collapsed
    ? "justify-center"
    : "justify-center lg:justify-start";

  return (
    <div className="min-h-screen bg-surface" dir="rtl">
      <div className="flex min-h-screen">
        {/* سایدبار: از تبلت به بالا نمایش داده می‌شود (روی تبلت جمع، روی دسکتاپ قابل تنظیم) */}
        <aside
          className={`sticky top-0 hidden h-screen shrink-0 py-4 pr-4 transition-all md:block md:w-20 ${
            collapsed ? "lg:w-24" : "lg:w-72"
          }`}
        >
          {/* دکمه جمع/باز کردن: فقط دسکتاپ، وسط عمودی لبه سایدبار */}
          <button
            onClick={() => setCollapsed((v) => !v)}
            className="absolute -left-3 top-1/2 hidden h-6 w-6 -translate-y-1/2 items-center justify-center rounded-full bg-navy text-white/50 shadow-md ring-1 ring-white/10 transition hover:text-white lg:flex"
          >
            <ChevronIcon collapsed={collapsed} />
          </button>

          <div className="flex h-full flex-col overflow-hidden rounded-[28px] bg-navy shadow-2xl shadow-navy/20 ring-1 ring-white/[0.04]">
            <div className="pt-5" />

            {/* دکمه ثبت قولنامه جدید */}
            <div className="px-3">
              <button
                onClick={onStartNewContract}
                disabled={!canCreateAgreement}
                title={
                  canCreateAgreement ? undefined : "سقف ثبت قولنامه شما تمام شده است"
                }
                className={`flex w-full items-center gap-2 rounded-2xl bg-gradient-to-l from-sky to-sky-dark px-4 py-3 text-sm font-bold text-white shadow-lg shadow-sky/25 transition hover:brightness-110 disabled:cursor-not-allowed disabled:from-gray-500 disabled:to-gray-600 disabled:shadow-none disabled:hover:brightness-100 ${rowJustify}`}
              >
                <PlusIcon />
                <span className={labelClass}>ثبت قرارداد جدید</span>
              </button>
              {limitError && !collapsed && (
                <p className="mb-5 mt-2 hidden rounded-xl bg-red-500/10 px-3 py-2 text-xs font-bold leading-6 text-red-200 lg:block">
                  {limitError}
                </p>
              )}
              {(!limitError || collapsed) && <div className="mb-5" />}
            </div>

            {/* آیتم‌های منو */}
            <nav className="flex-1 px-3">
              <div className="flex flex-col gap-1">
                {NAV_ITEMS.map((item) => {
                  const Icon = item.icon;
                  const active = activeTab === item.key;
                  return (
                    <button
                      key={item.key}
                      onClick={() => setActiveTab(item.key)}
                      className={`group relative flex items-center gap-3 rounded-2xl px-3 py-2.5 text-sm font-semibold transition ${rowJustify} ${
                        active
                          ? "bg-white/[0.08] text-white"
                          : "text-white/50 hover:bg-white/[0.05] hover:text-white/90"
                      }`}
                    >
                      {active && (
                        <span className="absolute right-0 top-1/2 h-5 w-[3px] -translate-y-1/2 rounded-full bg-sky-light" />
                      )}
                      <span
                        className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-xl transition ${
                          active
                            ? "bg-gradient-to-br from-sky to-sky-dark text-white shadow-sm shadow-sky/30"
                            : "bg-white/[0.06] text-white/40 group-hover:bg-white/[0.09] group-hover:text-sky-light"
                        }`}
                      >
                        <Icon />
                      </span>

                      <span className={`truncate ${labelClass}`}>
                        {item.label}
                      </span>
                    </button>
                  );
                })}
              </div>
            </nav>

            {/* پایین سایدبار: جمع‌کردن (فقط دسکتاپ) + کاربر + خروج */}
            <div className="mt-4 border-t border-white/[0.06] px-3 pb-4 pt-3">
              <div
                className={`mb-2 flex items-center gap-3 rounded-2xl px-2 py-2 ${rowJustify}`}
              >
                <div className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-sky/15 text-xs font-extrabold text-sky-light">
                  {initial}
                </div>
                <div className={`min-w-0 flex-1 ${labelClass}`}>
                  <p className="truncate text-xs font-bold text-white">
                    {userName || "کاربر"}
                  </p>
                </div>
              </div>
              <button
                onClick={onLogout}
                className={`flex w-full items-center gap-3 rounded-2xl px-3 py-2.5 text-sm font-bold text-white/50 transition hover:bg-red-500/10 hover:text-red-300 ${rowJustify}`}
              >
                <LogoutIcon />
                <span className={labelClass}>خروج از حساب</span>
              </button>
            </div>
          </div>
        </aside>

        {/* محتوای اصلی */}
        <div className="min-w-0 flex-1">
          {/* هدر موبایل */}
          <header className="sticky top-0 z-30 flex items-center justify-center border-b border-gray-100 bg-white/80 px-4 py-3 backdrop-blur md:hidden">
            <h1 className="text-sm font-extrabold text-navy">{activeLabel}</h1>
            <div className="w-9" />
          </header>

          <main className="mx-auto max-w-4xl px-4 py-6 pb-24 sm:px-6 md:pb-6 lg:px-10 lg:py-10">
            <h1 className="mb-6 hidden text-xl font-extrabold text-navy lg:block">
              {activeLabel}
            </h1>
            {renderTab()}
          </main>

          {/* نوار پایین موبایل: دکمه‌های ناوبری + ثبت قولنامه جدید، بدون خروج */}
          <nav className="fixed bottom-3 left-3 right-3 z-30 rounded-3xl bg-navy px-2 py-1 shadow-2xl shadow-navy/30 ring-1 ring-white/10 backdrop-blur md:hidden">
            {" "}
            <div className="flex items-center justify-around">
              {NAV_ITEMS.map((item) => {
                const Icon = item.icon;
                const active = activeTab === item.key;

                return (
                  <button
                    key={item.key}
                    onClick={() => setActiveTab(item.key)}
                    className="flex flex-1 flex-col items-center gap-1 rounded-2xl py-2"
                  >
                    <span
                      className={`flex h-10 w-10 items-center justify-center rounded-xl transition ${
                        active
                          ? "bg-gradient-to-br from-sky to-sky-dark text-white shadow-sm shadow-sky/30"
                          : "text-white/60"
                      }`}
                    >
                      <Icon />
                    </span>
                  </button>
                );
              })}

              <button
                onClick={onStartNewContract}
                disabled={!canCreateAgreement}
                title={
                  canCreateAgreement ? undefined : "سقف ثبت قولنامه شما تمام شده است"
                }
                className="flex flex-1 flex-col items-center gap-1 rounded-2xl py-2"
              >
                <span
                  className={`flex h-9 w-9 items-center justify-center rounded-xl text-white shadow-sm ${
                    canCreateAgreement
                      ? "bg-gradient-to-br from-sky to-sky-dark shadow-sky/30"
                      : "bg-gray-500 shadow-none"
                  }`}
                >
                  <PlusIcon />
                </span>
              </button>
            </div>
          </nav>
        </div>
      </div>
    </div>
  );
}

/* ---------- آیکون‌های SVG سبک ---------- */

function DocIcon() {
  return (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
      <path
        d="M7 3h7l5 5v13a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1Z"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinejoin="round"
      />
      <path
        d="M14 3v5h5"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinejoin="round"
      />
      <path
        d="M9 13h6M9 17h6"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
      />
    </svg>
  );
}

function WalletIcon() {
  return (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
      <rect
        x="3"
        y="6"
        width="18"
        height="13"
        rx="2.5"
        stroke="currentColor"
        strokeWidth="1.8"
      />
      <path d="M3 10h18" stroke="currentColor" strokeWidth="1.8" />
      <path
        d="M15 14.5h3"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
      />
    </svg>
  );
}

function UserIcon() {
  return (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
      <circle cx="12" cy="8" r="3.3" stroke="currentColor" strokeWidth="1.8" />
      <path
        d="M5 20c1.2-3.6 4-5.5 7-5.5s5.8 1.9 7 5.5"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
      />
    </svg>
  );
}

function PlusIcon() {
  return (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
      <path
        d="M12 5v14M5 12h14"
        stroke="currentColor"
        strokeWidth="2.2"
        strokeLinecap="round"
      />
    </svg>
  );
}

function LogoutIcon() {
  return (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
      <path
        d="M15 17.5V19a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h7a2 2 0 0 1 2 2v1.5"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9 12h12m0 0-3.5-3.5M21 12l-3.5 3.5"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function ChevronIcon({ collapsed }) {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 24 24"
      fill="none"
      className={`transition-transform ${collapsed ? "rotate-180" : ""}`}
    >
      <path
        d="M15 6l-6 6 6 6"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
